<template>
  <div>
    <SummaryComponent v-model="maximizeCard" :module_id="55"></SummaryComponent>

    <div class="p-2">
      <vs-card class="content_mb_0 mb-0">
        <div slot="header" class="flex flex-wrap justify-between items-center">
          <h4>Upcoming Lessons</h4>
          <div class="inline-flex items-center">
            <img
            v-if="yourImage"
              :src="yourImage"
              alt="user-img"
              width="40"
              height="40"
              class="rounded-full shadow-md cursor-pointer block"
            />
            <span v-else class="material-icons" style="font-size: 40px"
                >account_circle</span
              >
            <p class="pl-2">{{fullName}}(You)</p>
          </div>
        </div>
       <LessonTab />
      </vs-card>
    </div>

    <div class="flex flex-wrap">
      <div class="xl:w-1/4 lg:w-1/2 w-full p-2 h-full">
        <div class="card_container shadow_box p-4">
          <div class="flex items-center border_btm pb-4">
            <span class="material-icons-outlined">check_box</span>
            <h5 class="pl-2">Quick Task</h5>
          </div>
          <Task />
        </div>
      </div>
      <div class="xl:w-1/4 lg:w-1/2 w-full p-2 h-full">
        <div class="card_container shadow_box p-4">
          <div class="flex items-center border_btm pb-4">
            <span class="material-icons-outlined">email</span>
            <h5 class="pl-2">Quick Message/Email</h5>
          </div>
          <QuickTab />
        </div>
      </div>

      <div class="xl:w-1/4 lg:w-1/2 p-2 w-full h-full">
        <div class="card_container shadow_box p-4">
          <div class="flex items-center border_btm pb-4">
            <span class="material-icons-outlined">folder_special</span>
            <h5 class="pl-2">Recent files</h5>
          </div>
          <RecentFiles />
        </div>
      </div>

      <div class="xl:w-1/4 lg:w-1/2 p-2 w-full h-full">
        <div class="card_container shadow_box p-4">
          <div class="flex items-center border_btm pb-4">
            <span class="material-icons-outlined">fact_check</span>
            <h5 class="pl-2">Feed (posts)</h5>
          </div>
          <FeedPost />
        </div>
      </div>
    </div>

    <div class="flex flex-wrap">
      <div class="xl:w-1/2 w-full p-2 h-full">
        <vs-card class="content_mb_0 mb-0">
          <div slot="header">
            <h4>Student Attendance</h4>
          </div>
          <StudentAttendance />
        </vs-card>
      </div>

      <div class="xl:w-1/2 w-full p-2 h-full">
        <vs-card class="content_mb_0 mb-0">
          <div slot="header">
            <h4>Received Coursework/Exam/Report</h4>
          </div>
          <AssignmentComponent />
        </vs-card>
      </div>
    </div>


  </div>
</template>

<script>
import LessonTab from '@/views/pages/v1/Teacher/lessonsTab.vue'
import Task from '@/views/pages/v1/Admin/taskDashboard.vue'
import RecentFiles from '@/views/pages/v1/Admin/recentFiles.vue'
import StudentAttendance from '@/views/pages/v1/Teacher/studentAttendance.vue'
import FeedPost from '@/views/pages/v1/Admin/feedPost.vue'
import SummaryComponent from '@/views/pages/analytics/summeryLIst'
import QuickTab from '@/views/pages/v1/Teacher/quickTab.vue'
import AssignmentComponent from '@/views/pages/v1/Teacher/assignmentComponent.vue'


import vSelect from 'vue-select'


export default {
  name: 'student-dashboard',

  data () {
    return {
      yourImage:'',
      fullName:'',
      maximizeCard: true,
      attendance:null,
      addTaskPopup: false,

      staffChecked: true,
      parentsChecked: true,
      studentsChecked: true
    }
  },
  components: {
    vSelect,
    Task,
    RecentFiles,
    StudentAttendance,
    FeedPost,
    SummaryComponent,
    QuickTab,
    LessonTab,
    AssignmentComponent
  },
  mounted () {
    const firstName = JSON.parse(localStorage.getItem('userInfo')).first_name
    const last_name = JSON.parse(localStorage.getItem('userInfo')).last_name
    this.fullName = `${firstName } ${last_name}`
    this.yourImage = JSON.parse(localStorage.getItem('userInfo')).picture
  }
}
</script>